<template>
  <v-container fluid class="hoh-entry-form-entries-page no-padding-mobile">
    <!-- title -->
    <v-row justify="start" class="mb-4 mt-4 mx-4" v-if="selectedDate">
      <v-col cols="12" sm="12" md="12" lg="12" xl="11">
        <v-btn
          @click="$router.push({ name: 'Appointments' })"
          class="me-2"
          small
          elevation="0"
          text
          :style="$vuetify.breakpoint.xs ? 'margin-bottom: 20px' : ''"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          {{ translate($store.getters.content.back_calendar) }}
        </v-btn>
        <div class="font-weight-bold basil--text pb-2">
          <div class="text-center title">
            <v-btn fab @click="goToDay(-1)" class="me-4" small elevation="0" color="grey lighten-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-icon large color="grey darken-3">mdi-calendar</v-icon>
            <template v-if="selectedDate">{{ formatDate(selectedDate) }}</template>
            <v-btn fab @click="goToDay(1)" class="ms-4" small elevation="0" color="grey lighten-2">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider class="mt-2"></v-divider>
      </v-col>
    </v-row>
    <v-row justify="start" class="mx-4" :style="$vuetify.breakpoint.xs ? 'margin-left: 0 !important;margin-right: 0 !important;' : ''">
      <!-- appointments table -->
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" offset-md="3" class="no-padding-mobile">
        <TimeSlotsTable :selectedDate="selectedDate" :location="location" />
      </v-col>
    </v-row>

    <!-- Modals -->
    <AppointmentModalForm :doctorOptions="doctorOptions" :caseInfo="caseInfo" :location="location" />
  </v-container>
</template>

<script>
import moment from 'moment';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import Shared from '@/helpers/Shared.vue';
import TimeSlotsTable from '@/views/AppointmentsSelectedDayPage/components/time-slots-table.vue';
import AppointmentModalForm from '@/views/AppointmentsSelectedDayPage/components/appointment-modal-form.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    TimeSlotsTable,
    AppointmentModalForm,
  },
  data() {
    return {};
  },
  computed: {
    selectedDate() {
      return this.$route.params.selectedDate;
    },
    maxDate() {
      return this.$route.params.maxDate;
    },
    minDate() {
      return this.$route.params.minDate;
    },
    location() {
      return this.$route.params.location;
    },
    doctorOptions: {
      get() {
        return this.$store.state.intakeFormData.doctorOptions;
      },
      set(value) {
        this.$store.commit('SET_DOCTOR_OPTIONS', value);
      },
    },
    caseInfo() {
      return this.$store.getters.getPatientCase;
    },
  },
  created() {
    this.locale();
    if (this.doctorOptions.length == 0) {
      this.$store.dispatch('GET_DOCTOR_OPTIONS').then((data) => {
        this.doctorOptions = data;
      });
    }
  },
  methods: {
    formatDate(d) {
      return moment(d, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    goToDay(dayToGoTo) {
      const minDate = new Date(this.minDate);
      const maxDate = new Date(this.maxDate);
      const selectedDate = new Date(this.selectedDate);
      selectedDate.setDate(selectedDate.getDate() + dayToGoTo);

      if (selectedDate >= minDate && minDate != null && selectedDate <= maxDate && maxDate != undefined) {
        let day = moment(this.selectedDate, 'YYYY-MM-DD').add(dayToGoTo, 'days');
        this.$router.push(`/appointment/${day.format('YYYY-MM-DD')}/${this.minDate}/${this.maxDate}/${this.location}`);
      }
    },
    locale() {
      const locale = Shared.locale();
      if (locale != '') {
        moment.locale(locale);
      }
    },
  },
};
</script>

<style lang="scss"></style>
